export default __webpack_public_path__ + "static/Bedstead-Regular-f4327e5b3c2f190566df05634bd43630.otf";